import { getToken } from "firebase/messaging";
import { messaging, VAPID_KEY } from "./config/firebaseconfig";
import { updateFCMToken as updateFCMTokenService } from "./services/authService";

export const requestFCMTokenAndSave = async (email) => {
  try {
    console.log("[FCM] Requesting notification permission...");
    const permission = await Notification.requestPermission();
    console.log("[FCM] Notification permission status:", permission);

    if (permission !== "granted") {
      console.log("[FCM] Notification permission was not granted.");
      return;
    }

    console.log("[FCM] Retrieving FCM token...");

    // ✅ SIMPLIFIED — no service worker handling
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    if (!token) {
      console.log("[FCM] Failed to generate FCM token.");
      return;
    }

    console.log("[FCM] FCM Token:", token);

    console.log(`[FCM] Saving token for ${email}...`);

    await updateFCMTokenService({
      email,
      fcmToken: token,
    });

    console.log("[FCM] Token saved successfully.");

  } catch (error) {
    console.error("[FCM] Error getting/saving token:", error);
  }
};